import type { Design, Setbacks } from "../design"

export const DEFAULT_SETBACKS_IN_INCHES: Setbacks = {
  ridge: 36,
  eave: 0,
  hip: 18,
  rake: 36,
  valley: 18,
}

// the graphQL type is insufficient for the design state
// since many fields are JSON-typed

// [eyecue-codemap-group:9PaVBf7tv1S]
export const DEFAULT_DESIGN: Design = {
  id: ``,
  createdAt: new Date(),
  updatedAt: new Date(),
  roofType: null,
  activatedAt: null,
  designEquipment: [],
  batteryCompatibility: false,
  brochurePositionX: 0,
  brochurePositionY: 0,
  brochureZoom: 1.1,
  completedAt: null,
  annualProduction: null,
  annualOffset: null,
  systemSizeKw: null,
  displayImageryProvider: `nearmap`,
  edges: {},
  energyBackup: null,
  energyBackupId: null,
  profiles: [],
  energyEfficiencyKitRebate: false,
  energyEfficiencyKitRebateAmount: 0,
  evCharger: false,
  evOutlet: false,
  extendedWarrantyPowurOsId: null,
  extendedWarrantyName: null,
  extendedWarrantySpanishName: null,
  extendedWarrantyFamily: null,
  extendedWarrantyCost: null,
  estimates: [],
  optimalEstimate: null,
  homeownerRebate: false,
  homeownerRebateAmount: 0,
  installAreas: {},
  installAreasToPanels: [],
  inverter: null,
  inverterId: null,
  inverterManufacturer: null,
  nodes: {},
  obstructions: {},
  panels: {},
  phase: `Image Selection`,
  proposalId: ``,
  roofWorkRebate: false,
  roofWorkRebateAmount: 0,
  savings: null,
  secondaryInverter: null,
  secondaryInverterId: null,
  setbacks: DEFAULT_SETBACKS_IN_INCHES,
  shadingAreas: {},
  source: `vision`,
  sunroofCheckedAt: null,
  tool: `Pan`,
  openSolarImage: null,
  treeTrimmingRebate: false,
  treeTrimmingRebateAmount: 0,
  type: `clay_tile`, // using ROOF_TYPES[0] causes an error about reading undefined for some reason
  parentId: null,
  designRequestId: null,
  name: ``,
}
//[end-eyecue-codemap-group:9PaVBf7tv1S:2ea7a1b088df0fef2d966a4c84c40987f08e32cd]

export const MAX_AUTO_PLACED_PANELS = 100
